import { Button, Card, DisplayText } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export function ItPlanContact() {
  return (
    <div className="p2040 flex actr jctr fh w100">
      <Card padding="sizeMedium" noShadow>
        <div className="flex col actr g20">
          <DisplayText element="p" size="extraLarge">
            <FormattedMessage id="itsm.billing.description" />
          </DisplayText>
          <Button primary onClick={() => window.Intercom('show')} plain>
            <FormattedMessage id="itsm.billing.contact.sales" />
          </Button>
        </div>
      </Card>
    </div>
  );
}
